import React from 'react';
import { Card, Typography } from 'antd';

const { Title, Text } = Typography;

interface PanelTabCardProps {
  title: string;
  description?: React.ReactNode;
  children: React.ReactNode;
}

const PanelTabCard: React.FC<PanelTabCardProps> = ({ title, description, children }) => (
  <div className="panel-tab-content">
    <Card>
      <div style={{ marginBottom: 16 }}>
        <Title level={4} style={{ margin: 0 }}>{title}</Title>
        {description != null && (
          <Text type="secondary" style={{ display: 'block', marginTop: 4 }}>
            {description}
          </Text>
        )}
      </div>
      {children}
    </Card>
  </div>
);

export default PanelTabCard;
